// AuthPage.tsx
import React, { useState, useEffect } from 'react'
import { useNavigate }    from 'react-router-dom'
import { useAuth }        from '../auth/AuthContext'
import api from '../api/axios'
import './AuthPage.css'

import bgImg     from '../assets/login/bg.png'
import buttonImg from '../assets/login/button.png'
import tgImg     from '../assets/login/tg.png'
import xImg      from '../assets/login/x.png'
import img1      from '../assets/login/img1.png'
import img2      from '../assets/login/img2.png'
import img3      from '../assets/login/img3.png'

// augment Window for Phantom
declare global {
  interface Window {
    solana?: {
      connect: (opts?: { onlyIfTrusted: boolean }) => Promise<{ publicKey: { toString(): string } }>
    }
  }
}

const isMobile = (): boolean => {
  if (typeof navigator === 'undefined') return false
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/.test(navigator.userAgent)
}

const AuthPage: React.FC = () => {
  const [mode, setMode]         = useState<'login'|'register'>('login')
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [error, setError]       = useState<string|null>(null)
  const [imgIndex, setImgIndex] = useState(0)
  const images = [img1, img2, img3]
  const navigate                = useNavigate()
  const { login, loginWithWallet } = useAuth()

  useEffect(() => {
    if (isMobile()) {
      setError(null)
    }
  }, [])

  const prevImage = () => setImgIndex((i) => (i - 1 + images.length) % images.length)
  const nextImage = () => setImgIndex((i) => (i + 1) % images.length)

  // Mobile warning screen
  if (isMobile()) {
    return (
      <div
        className="auth-page mobile-warning"
        style={{ backgroundImage: `url(${bgImg})` }}
      >
        <div className="mobile-warning-box">
          <h2>Unsupported Device</h2>
          <p>This app is only supported in desktop browsers.</p>
          <div className="social-links mobile">
            <a href="https://t.me/SolQuestGame" target="_blank" rel="noreferrer noopener">
              <img src={tgImg} alt="Telegram" />
            </a>
            <a href="https://x.com/SolQuestGame" target="_blank" rel="noreferrer noopener">
              <img src={xImg} alt="X" />
            </a>
          </div>
          <div className="mobile-carousel">
            <button className="carousel-btn prev" onClick={prevImage}>&lt;</button>
            <img src={images[imgIndex]} alt={`Slide ${imgIndex+1}`} />
            <button className="carousel-btn next" onClick={nextImage}>&gt;</button>
          </div>
        </div>
      </div>
    )
  }

  const handleEmail = async (e: React.FormEvent) => {
    e.preventDefault()
    try {
      setError(null)
      if (mode === 'login') {
        await login(email, password)
      } else {
        await api.post('/auth/register', { email, password })
        await login(email, password)
      }
      navigate('/character')
    } catch (err: any) {
      setError(err.response?.data?.error || err.message)
    }
  }

  const handleWallet = async () => {
    try {
      setError(null)
      if (!window.solana) throw new Error('Phantom not detected')
      const resp   = await window.solana.connect({ onlyIfTrusted: false })
      const pubkey = resp.publicKey.toString()
      await loginWithWallet(pubkey)
      navigate('/character')
    } catch (err: any) {
      setError(err.response?.data?.error || err.message)
    }
  }

  return (
    <div
      className="auth-page"
      style={{ backgroundImage: `url(${bgImg})` }}
    >
      <div className="social-links">
        <a href="https://t.me/SolQuestGame" target="_blank" rel="noreferrer noopener">
          <img src={tgImg} alt="Telegram" />
        </a>
        <a href="https://x.com/SolQuestGame" target="_blank" rel="noreferrer noopener">
          <img src={xImg} alt="X" />
        </a>
      </div>
      <div className="auth-container">
        <div className="mode-switch">
          <button
            className={`mode-btn${mode==='login'? ' active' : ''}`}
            onClick={()=>setMode('login')}
          >Login</button>
          <button
            className={`mode-btn${mode==='register'? ' active' : ''}`}
            onClick={()=>setMode('register')}
          >Register</button>
        </div>
        <form className="auth-form" onSubmit={handleEmail}>
          <h2>{mode === 'login' ? 'Login' : 'Register'}</h2>
          {error && <p className="auth-error">{error}</p>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={e=>setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={e=>setPassword(e.target.value)}
            required
          />
          <button
            type="submit"
            className="action-btn"
            style={{ backgroundImage: `url(${buttonImg})` }}
          >
            {mode === 'login' ? 'Login' : 'Register'}
          </button>
        </form>
        <hr className="auth-divider" />
        <button
          onClick={handleWallet}
          className="action-btn wallet-btn"
          style={{ backgroundImage: `url(${buttonImg})` }}
        >
          Connect Wallet
        </button>
      </div>
    </div>
  )
}
export default AuthPage;